export default "__VITE_ASSET__C5YTOe1F__"